import MyLocationIcon from "@mui/icons-material/MyLocation";
import Marker from "../markers/Marker";

const SimpleLocationMarker = () => {
	return (
		<Marker color="#4C9EDF" icon={<MyLocationIcon />} />
	);
};

export default SimpleLocationMarker;
